// Copyright (c) 2017 Deere & Company

import ReportVariant, {getDefaultState} from '../state/report-variant';
import actions from '../../actions-list';

const updateGridLayout = (state, action) =>
    ReportVariant.update(state, {
        layouts: {
            $set: action.data
        },
        selectedLayout: {
            $set: action.selectedLayout
        }
    });

const updateProperty = (state, action) =>
    ReportVariant.update(state, {
        [action.property]: {
            $set: action.value
        }
    });

const updateDefaultLayout = (state, action) => {

    const defaultLayoutIndex = state.layouts.findIndex(layout => layout.name === '');

    return ReportVariant.update(state, {
        layouts: {
            [defaultLayoutIndex]: {
                columnState: {
                    $set: action.columnState
                },
                sortModel: {
                    $set: action.sortModel
                }
            }
        }
    });

};

const hideReportColumn = (state, action) =>
    ReportVariant.update(state, {
        selectedLayout: {
            columnState: {
                $set: action.columnState
            }
        }
    });

const updateCreateLayoutModal = (state, action) =>
    ReportVariant.update(state, {
        createLayoutModal: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const updateExistingLayout = (state, action) =>

    ReportVariant.update(state, {
        selectedLayout: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const toggleReportColumns = (state, action) =>
    ReportVariant.update(state, {
        isReportColumnsVisible: {
            $set: action.isVisible
        }
    });

const toggleUpdateLayoutModal = (state, action) =>
    ReportVariant.update(state, {
        isUpdateLayoutModalOpen: {
            $set: action.isOpen
        }
    });

const showReportColumn = (state, action) => {

    const columnToBeAdded = {
        ...state.selectedLayout.columnState[action.columnIndex],
        hide: false
    };

    const columnState = ReportVariant.update(state, {
        selectedLayout: {
            columnState: {
                $splice: [[action.columnIndex, 1]]
            }
        }
    }).selectedLayout.columnState;

    return ReportVariant.update(state, {
        selectedLayout: {
            columnState: {
                $set: [columnToBeAdded, ...columnState]
            }
        }

    });

};

const resetCreateLayoutModal = state =>
    ReportVariant.update(state, {
        createLayoutModal: {
            $set: getDefaultState().createLayoutModal
        },
        isUpdateLayoutModalOpen: {
            $set: getDefaultState().isUpdateLayoutModalOpen
        }

    });

const resetReportVariant = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.HIDE_REPORT_COLUMN]: hideReportColumn,
        [actions.RESET_CREATE_LAYOUT_MODAL]: resetCreateLayoutModal,
        [actions.RESET_REPORT_VARIANT]: resetReportVariant,
        [actions.SHOW_REPORT_COLUMN]: showReportColumn,
        [actions.TOGGLE_REPORT_COLUMNS_VISIBILITY]: toggleReportColumns,
        [actions.UPDATE_CREATE_LAYOUT_MODAL]: updateCreateLayoutModal,
        [actions.UPDATE_DEFAULT_REPORT_LAYOUT]: updateDefaultLayout,
        [actions.UPDATE_EXISTING_LAYOUT]: updateExistingLayout,
        [actions.UPDATE_LAYOUT_MODAL]: toggleUpdateLayoutModal,
        [actions.UPDATE_REPORT_GRID_LAYOUT_PROPERTY]: updateProperty,
        [actions.UPDATE_REPORT_GRID_LAYOUTS]: updateGridLayout
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/shared/reducers/report-variant.js